import { ThirdPartySensorDetailsPage } from 'pages/Settings/ThirdPartySensorModels/ThirdPartySensorDetailsPage';
import { ThirdPartySensorsPage } from 'pages/Settings/ThirdPartySensorModels/ThirdPartySensorsPage';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

export function ThirdPartySensorsRouter() {
    const { url } = useRouteMatch();

    return (
        <Switch>
            <Route
                path={`${url}/details/:sensorModelId`}
                render={({ match }) => (
                    <ThirdPartySensorDetailsPage
                        sensorModelId={match.params.sensorModelId}
                    />
                )}
            />
            <Route path={url} render={() => <ThirdPartySensorsPage />} />
        </Switch>
    );
}
